import { ActivityFeed } from "@/components/ui";
import { useChecklistItemActivities } from "@/hooks/use-checklist-item-activities";
import type { ChecklistItemId } from "@/packages/types";

interface ActivityContentProps {
  checklistItemId: ChecklistItemId;
}

export function ActivityContent({ checklistItemId }: ActivityContentProps) {
  const { activities, isLoading } = useChecklistItemActivities(checklistItemId);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-12">
        <div className="flex flex-col items-center gap-3">
          <div className="w-7 h-7 rounded-full border-2 border-accent border-t-transparent animate-spin" />
          <p className="text-xs text-muted">Loading activity…</p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col min-h-0">
      <ActivityFeed
        items={activities}
        emptyTitle="No activity yet"
        emptyDescription="Actions on this checklist item will appear here."
      />
    </div>
  );
}
